import axios from "axios";
import { authHeader, multipartHeader } from "./auth-header";

export const getSubSpaces = async (filterText = '', page = 1, perPage = 10) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}getAllSubSpaces`, {
      params: {
        filterText, // Search filter text
        page,       // Current page for pagination
        perPage,    // Number of items per page
      },
    });

    console.log(response.data.data, 'data');
    return response.data.data; // The data returned from the backend
  } catch (error) {
    console.error('Error fetching subspaces:', error);
    throw error; // You can also handle this error depending on your app's error management strategy
  }
};

export const createSubSpace = async (subSpace) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}createSubSpaces`,subSpace,{
    headers: authHeader(),
  });
  console.log(response,"createrees");
  
  return response.data;
};

export const updateSubSpace = async (subSpace) => {
  console.log(subSpace.id,"inder");
  
  const response = await axios.post(`${process.env.REACT_APP_API_URL}admins/updateSubSpaceById/${subSpace.id}`,subSpace,{
    headers:authHeader(),
  });
  return response.data;
};

export const deleteSubSpace = async (id) => {
  const response = await axios.delete(`${process.env.REACT_APP_API_URL}deleteSubSpacesById/${id}`,{
    headers: authHeader(),
    
  });
  console.log(response,"delete response");
  
  return response.data;
};
